/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Forside_Safe_3_TitleInputs */

const da_forside_safe_3_title = /** @type {(inputs: Forside_Safe_3_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kun du ser dine data`)
};

/** @type {(inputs: Forside_Safe_3_TitleInputs) => LocalizedString} */
const en_forside_safe_3_title = da_forside_safe_3_title;

/**

* @param {Forside_Safe_3_TitleInputs} inputs
* @param {{ locale?: "da" | "en" }} options
* @returns {LocalizedString}
*/
export const forside_safe_3_title = /** @type {((inputs?: Forside_Safe_3_TitleInputs, options?: { locale?: "da" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Forside_Safe_3_TitleInputs, { locale?: "da" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_forside_safe_3_title(inputs)
	return /** @type {LocalizedString} */ ("Kun du ser dine data")
});